import React from "react";

import PlusPage from "./PlusPage";

const PlusModal = () => {
  return <PlusPage type="modal" />;
};

export default PlusModal;
